/* eslint-disable no-undef */
import {getTranslation} from './translations';

const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;


const template = `
	<div class="ubf-dynamicList__filterDateContainer">
		<div class="ubf-dynamicList__filter ubf-dynamicList__filter--date">
			<label for="from">{{ trans('after') }}</label>
			<div class="ubf-dynamicList__dateInputs">
				<input class="ubf-dynamicList__input ubf-dynamicList__input--date" type="date" :disabled="localFrom === 'now'" :value="localFrom" :placeholder="description" @input="onFromInput" @blur="onFromInput" id="from"/>
				<label><input type="checkbox" id="fromToday" :value="localFromToday" @change="onFromTodayChange"> {{trans('today')}}</label>
			</div>
		</div>
		<div class="ubf-dynamicList__filter ubf-dynamicList__filter--date">
			<label for="to">{{ trans('before') }}</label>
			<div class="ubf-dynamicList__dateInputs">
				<input class="ubf-dynamicList__input ubf-dynamicList__input--date" type="date" :disabled="localTo === 'now'" :value="localTo" :placeholder="description" @input="onToInput" @blur="onToInput" id="to"/>
				<label><input type="checkbox" id="toToday" :value="localToToday" @change="onToTodayChange"> {{trans('today')}}</label>
			</div>
		</div>
	</div>
`;

export default {
    emits: ['input', 'change'],
    template: template,
    props: {
        label: String,
        from: String,
		fromToday: Boolean,
		to: String,
		toToday: Boolean,
        description: String
    },
    setup: function (props, context) {
		const localFrom = ref(props.from);
		const localFromToday = ref();
		if (!props.from) {
			localFrom.value = '';
		}
		if (!props.fromToday) {
			localFromToday.value = false;
		}
		const localTo = ref(props.to);
		const localToToday = ref();
		if (!props.to) {
			localTo.value = '';
		}
		if (!props.toToday) {
			localToToday.value = false;
		}
		watch(
			() => props.from, (newVal) => {
				if (newVal === 'now') {
					localFromToday.value = true;
				} else {
					localFrom.value = newVal;
				}
			}
		);
		watch(
			() => props.fromToday, (newVal) => {localFromToday.value = newVal;}
		);
		watch(
			() => props.to, (newVal) => {
				if (newVal === 'now') {
					localToToday.value = true;
				} else {
					localTo.value = newVal;
				}
			}
		);
		watch(
			() => props.toToday, (newVal) => {localToToday.value = newVal;}
		);

		return {
			trans: getTranslation,
			localFrom: localFrom,
			localFromToday: localFromToday,
			localTo: localTo,
			localToToday: localToToday,
            label: props.label,
            description: props.description,
        };
    },

	methods: {
		onFromInput: function(event) {
			let to = this.localTo;
			if (to !== '' && event.target.value > to) {
				to = event.target.value;
			}
			this.$emit('input', {
				from: event.target.value,
				to: to
			});
		},
		onFromTodayChange: function(event) {
			console.log('onFromTodayChange', event.target.checked, this.localTo);
			this.localFrom = event.target.checked ? 'now' : ''; // set date based on checkbox
			this.$emit('input', {
				from: this.localFrom,
				to: this.localTo
			});
		},
		onToInput: function(event) {
			let from = this.localFrom;
			if (from!== '' && event.target.value < from) {
				from = event.target.value;
			}
			this.$emit('input', {
				to: event.target.value,
				from: from
			});
		},
		onToTodayChange: function(event) {
			console.log('onToTodayChange', event.target.checked, this.localFrom);
			this.localTo = event.target.checked ? 'now' : ''; // set date based on checkbox
			this.$emit('input', {
				from: this.localFrom,
				to: this.localTo
			});
		},
	},
};

